import { createContext, useCallback, useContext, useRef, useState } from "react";
import {
  Building2, CalendarCheck, ClipboardCheck, RefreshCw, ShieldCheck, Trophy, Undo2, UserCheck, UserPlus, Wallet,
} from "lucide-react";

// Full-screen ~2s "milestone" celebration, deliberately reserved for genuinely important
// moments (per explicit product decision) — new member, payment, renewal, refund, class
// booking, staff added, plan created, password changed, gym provisioned, trial converted.
// Routine saves (a note, availability, etc.) stay on the existing toast pattern.
export const CELEBRATIONS = {
  member_added: { icon: UserPlus, title: "New member added!" },
  payment_collected: { icon: Wallet, title: "Payment collected!" },
  membership_renewed: { icon: RefreshCw, title: "Membership renewed!" },
  refund_processed: { icon: Undo2, title: "Refund processed!" },
  class_booked: { icon: CalendarCheck, title: "Class booked!" },
  staff_added: { icon: UserCheck, title: "Staff added!" },
  plan_created: { icon: ClipboardCheck, title: "Plan created!" },
  password_changed: { icon: ShieldCheck, title: "Password changed!" },
  gym_provisioned: { icon: Building2, title: "Gym provisioned!" },
  trial_converted: { icon: Trophy, title: "Trial converted to paid!" },
};

const DURATION_MS = 2000;

const CelebrationCtx = createContext(null);

export function CelebrationProvider({ children }) {
  const [active, setActive] = useState(null);
  const timerRef = useRef(null);

  const celebrate = useCallback((key, detail) => {
    const preset = CELEBRATIONS[key];
    if (!preset) return;
    clearTimeout(timerRef.current);
    setActive({ ...preset, detail, id: `${key}-${Date.now()}` });
    timerRef.current = setTimeout(() => setActive(null), DURATION_MS);
  }, []);

  return (
    <CelebrationCtx.Provider value={{ active, celebrate }}>
      {children}
    </CelebrationCtx.Provider>
  );
}

export function useCelebration() {
  return useContext(CelebrationCtx);
}
